import {
  RadioButton as KendoRadioButton,
  RadioButtonProps,
} from '@progress/kendo-react-inputs';

interface IRadioButtonProps {}

const RadioButton = (props: IRadioButtonProps & RadioButtonProps) => {
  return (
    <div className="radiobutton-wrap">
      <KendoRadioButton {...props} />
    </div>
  );
};

export default RadioButton;
